import { PayloadAction, createSlice } from "@reduxjs/toolkit";
import { ReactNode } from "react";
import { RootSearchState } from "../types/rootSearchTypes";

const initialState: RootSearchState = {
  rootSearch: null,
};

const rootSearchSlice = createSlice({
  name: "rootSearch",
  initialState,
  reducers: {
    setRootSearch: (state, action: PayloadAction<ReactNode>) => {
      state.rootSearch = action.payload;
    },
  },
});

export const { actions: rootSearchActions, reducer: rootSearchReducer } = rootSearchSlice; 